import React, {useState, useEffect} from 'react';
import { TextField } from '@mui/material';

const TextFiledWithLabel = ({helperText, type, isViewMode,name, label, className="", value, handleOnChange, ...otherProps}) => {

    return (
        <TextField
            sx = {{width : "210px"}}
            disabled = {isViewMode}
            name={name}
            label={label}
            type={type}
            variant="standard"
            className={className}
            onChange={handleOnChange}
            value={value ?? ""}
            defaultValue={""}
            helperText = {helperText || ""}
            {...otherProps}
            InputLabelProps={type == 'date' && {
                shrink: true,
            }}
        />

    )
}

export default TextFiledWithLabel; 